// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2UEQw","colCheckbox":"styles_colCheckbox__3MWL5"};